module.exports = __webpack_public_path__ + "media/images/logo/Oneticket_tour__black-760e510d0eaaec716d8ec33afd3c8d40.svg";